import React, { useState } from "react";
import { Title, Meta, Link as HeadLink } from "react-head";
import { motion } from "motion/react";
import { useParams, useNavigate } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";

import WallpaperCatBar from "../components/Client/WallpaperCatBar";
import WallpaperGrid from "../components/Client/WallpaperGrid";
import ClientAdSense from "../components/Client/ClientAdSense";
import FixedButton from "../components/Client/FixedButton";
import WallpaperFooter from "../components/Client/WallpaperFooter";

const ClientWallpaperCategory = () => {
    const { slug } = useParams();
    const navigate = useNavigate();

    const [category, setCategory] = useState(null);
    const [total, setTotal] = useState(0);
    const [notFound, setNotFound] = useState(false);

    const onMeta = (r) => {
        if (r?.status) {
            if (r.category) setCategory(r.category);
            setTotal(r.totalRecords || 0);
            setNotFound(false);
        } else {
            setNotFound(true);
        }
    };

    const heading = category?.w_name || slug;

    return (
        <div className='min-h-screen dm-sans client-home-bg'>
            <Title>{heading} Wallpapers | PicPromptify</Title>
            <Meta
                name='description'
                content={`Download free HD ${heading} wallpapers (1080×1920) on PicPromptify.`}
            />
            <Meta property='og:title' content={`${heading} Wallpapers | PicPromptify`} />
            <Meta property='og:type' content='website' />
            <HeadLink
                rel='canonical'
                href={`https://picpromptify.com/wallpaper/category/${slug}`}
            />

            {/* top scrollable category bar — current slug active (no navbar) */}
            <WallpaperCatBar activeSlug={slug} />
            <FixedButton />

            <section className='relative w-full px-4 sm:px-6 md:px-8 pt-5 md:pt-7 pb-12 md:pb-20'>
                <div className='mx-auto max-w-7xl'>
                    {/* top banner ad */}
                    <ClientAdSense
                        slot='9729451986'
                        containerClassName='w-full mb-5 md:mb-7'
                    />

                    {/* header: back + title + count */}
                    <div className='flex items-center justify-between gap-3 mb-5 md:mb-7'>
                        <div className='flex items-center gap-3 min-w-0'>
                            <motion.button
                                whileHover={{ x: -3 }}
                                whileTap={{ scale: 0.95 }}
                                onClick={() => navigate("/wallpaper")}
                                className='ios-glass-btn inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-client-font/85 text-[11px] md:text-xs font-medium flex-shrink-0'
                            >
                                <FiArrowLeft className='text-sm' />
                                Back
                            </motion.button>
                            <div className='flex items-center gap-2 min-w-0'>
                                <div
                                    className='w-1 h-6 rounded-full flex-shrink-0'
                                    style={{
                                        background:
                                            "linear-gradient(180deg, #7F00FF, #FCFA02)",
                                    }}
                                />
                                <h1 className='text-client-font font-semibold text-sm md:text-lg tracking-wide truncate capitalize'>
                                    {heading}
                                </h1>
                            </div>
                        </div>
                        {total > 0 && (
                            <div className='ios-glass px-3 py-1 rounded-full text-client-font/75 text-[10px] md:text-xs flex-shrink-0'>
                                <span className='tabular-nums font-bold text-client-title'>
                                    {total}
                                </span>{" "}
                                wallpapers
                            </div>
                        )}
                    </div>

                    {/* key={slug} → remount on category switch (clean state, no race) */}
                    <WallpaperGrid
                        key={slug}
                        slug={slug}
                        onMeta={onMeta}
                        emptyTitle={notFound ? "Category not found" : "No wallpapers yet"}
                        emptyText={
                            notFound
                                ? "This collection isn't available right now."
                                : "Check back soon for fresh wallpapers."
                        }
                    />
                </div>
            </section>

            <WallpaperFooter />
        </div>
    );
};

export default ClientWallpaperCategory;
